const convertToObj = (a, b) => {
  if (a.length !== b.length || a.length === 0 || b.length === 0) {
    return null;
  }

  /**  Using Object.assign method */
  return Object.assign(...a.map((k, i) => ({ [k]: b[i] })));
};
export default convertToObj;
